import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowCircleUp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 12,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1154 26.1154L20.1154 14.3461",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.1154 19.8846L20.1154 13.8846L14.1154 19.8846",
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgArrowCircleUp);
export default ForwardRef;
